import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { anyToHash, filtersToQueryParams } from "utils/misc";

export default function useAdminVouchers(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchVouchers() {
      setLoading(true);
      const { response, data } = await API.fetchVouchers(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    fetchVouchers();
  }, [anyToHash(filters)]);

  return {
    loading,
    vouchers: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
